import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $PaymentMethod = tag => ({tag});
const SplitPaymentInfo = x => x;
const Cash = /* #__PURE__ */ $PaymentMethod("Cash");
const Online = /* #__PURE__ */ $PaymentMethod("Online");
const Card = /* #__PURE__ */ $PaymentMethod("Card");
const Prepaid = /* #__PURE__ */ $PaymentMethod("Prepaid");
const Offline = /* #__PURE__ */ $PaymentMethod("Offline");
const CashAndCard = /* #__PURE__ */ $PaymentMethod("CashAndCard");
const BankTransfer = /* #__PURE__ */ $PaymentMethod("BankTransfer");
const newtypeSplitPaymentInfo_ = {Coercible0: () => {}};
const hasFieldSplitPaymentInfo = dictHasField => dictHasField;
const eqSplitPaymentInfo = {eq: x => y => x.cardAmount === y.cardAmount && x.cashAmount === y.cashAmount};
const eqPaymentMethod = {
  eq: x => y => {
    if (x.tag === "Cash") { return y.tag === "Cash"; }
    if (x.tag === "Online") { return y.tag === "Online"; }
    if (x.tag === "Card") { return y.tag === "Card"; }
    if (x.tag === "Prepaid") { return y.tag === "Prepaid"; }
    if (x.tag === "Offline") { return y.tag === "Offline"; }
    if (x.tag === "CashAndCard") { return y.tag === "CashAndCard"; }
    if (x.tag === "BankTransfer") { return y.tag === "BankTransfer"; }
    return false;
  }
};
const ordPaymentMethod = {
  compare: x => y => {
    if (x.tag === "Cash") {
      if (y.tag === "Cash") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Cash") { return Data$dOrdering.GT; }
    if (x.tag === "Online") {
      if (y.tag === "Online") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Online") { return Data$dOrdering.GT; }
    if (x.tag === "Card") {
      if (y.tag === "Card") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Card") { return Data$dOrdering.GT; }
    if (x.tag === "Prepaid") {
      if (y.tag === "Prepaid") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Prepaid") { return Data$dOrdering.GT; }
    if (x.tag === "Offline") {
      if (y.tag === "Offline") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Offline") { return Data$dOrdering.GT; }
    if (x.tag === "CashAndCard") {
      if (y.tag === "CashAndCard") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "CashAndCard") { return Data$dOrdering.GT; }
    if (x.tag === "BankTransfer") {
      if (y.tag === "BankTransfer") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqPaymentMethod
};
const genericSplitPaymentInfo = {to: x => x, from: x => x};
const showSplitPaymentInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["cardAmount", Data$dMoney$dRounded.toString(v.cardAmount)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "cashAmount",
            Data$dMoney$dRounded.toString(v.cashAmount)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "SplitPaymentInfo"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeSplitPaymentInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble$dGeneric.genericUnsafeDecodeTagged(genericSplitPaymentInfo)(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "SplitPaymentInfo"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "cardAmount"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "cashAmount"
      })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.defaultOptions)
  }
))();
const genericPaymentMethod = {
  to: x => {
    if (x.tag === "Inl") { return Cash; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Online; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Card; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return Prepaid; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return Offline; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return CashAndCard; }
              if (x._1._1._1._1._1.tag === "Inr") { return BankTransfer; }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Cash") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Online") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Card") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "Prepaid") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "Offline") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "CashAndCard") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "BankTransfer") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    $runtime.fail();
  }
};
const showPaymentMethod = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Cash"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Online"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Card"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Prepaid"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Offline"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "CashAndCard"});
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "BankTransfer"});
    return x => {
      const $7 = genericPaymentMethod.from(x);
      if ($7.tag === "Inl") { return $0["genericShow'"]($7._1); }
      if ($7.tag === "Inr") {
        if ($7._1.tag === "Inl") { return $1["genericShow'"]($7._1._1); }
        if ($7._1.tag === "Inr") {
          if ($7._1._1.tag === "Inl") { return $2["genericShow'"]($7._1._1._1); }
          if ($7._1._1.tag === "Inr") {
            if ($7._1._1._1.tag === "Inl") { return $3["genericShow'"]($7._1._1._1._1); }
            if ($7._1._1._1.tag === "Inr") {
              if ($7._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($7._1._1._1._1._1); }
              if ($7._1._1._1._1.tag === "Inr") {
                if ($7._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($7._1._1._1._1._1._1); }
                if ($7._1._1._1._1._1.tag === "Inr") { return $6["genericShow'"]($7._1._1._1._1._1._1); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePaymentMethod = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericPaymentMethod)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Cash"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Online"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Card"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Prepaid"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Offline"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("CashAndCard"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("BankTransfer"), Data$dGeneric$dRep.NoArguments)]})))))))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedPaymentMethod = /* #__PURE__ */ (() => (
  {
    top: genericPaymentMethod.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
      )
    )),
    bottom: genericPaymentMethod.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordPaymentMethod
  }
))();
const enumPaymentMethod = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericPaymentMethod)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  })),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericPaymentMethod)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  })),
  Ord0: () => ordPaymentMethod
};
const boundedEnumPaymentMethod = /* #__PURE__ */ (() => (
  {
    cardinality: Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))))))[
      "genericCardinality'"
    ],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericPaymentMethod)(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))))))),
    fromEnum: (() => {
      const $0 = Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))))));
      return x => $0["genericFromEnum'"](genericPaymentMethod.from(x));
    })(),
    Bounded0: () => boundedPaymentMethod,
    Enum1: () => enumPaymentMethod
  }
))();
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeSplitPaymentInfo = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "SplitPaymentInfo"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "cashAmount"})({
        encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode
      }))({reflectSymbol: () => "cardAmount"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts({
      sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
      unwrapSingleConstructors: false,
      unwrapSingleArguments: true,
      unwrapSingleRecordArguments: true,
      fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
    })
  }
))();
const encodePaymentMethod = {
  encode: x => {
    const $0 = genericPaymentMethod.from(x);
    if ($0.tag === "Inl") { return "Cash"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "Online"; }
      if ($0._1.tag === "Inr") {
        if ($0._1._1.tag === "Inl") { return "Card"; }
        if ($0._1._1.tag === "Inr") {
          if ($0._1._1._1.tag === "Inl") { return "Prepaid"; }
          if ($0._1._1._1.tag === "Inr") {
            const $1 = $0._1._1._1._1;
            if ($1.tag === "Inl") { return "Offline"; }
            if ($1.tag === "Inr") {
              if ($1._1.tag === "Inl") { return "CashAndCard"; }
              if ($1._1.tag === "Inr") { return "BankTransfer"; }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const decodeSplitPaymentInfo = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric.genericDecode(genericSplitPaymentInfo)(Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "SplitPaymentInfo"})(Foreign$dGeneric$dClass.genericDecodeArgsRecord(Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "cashAmount"
    })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "cardAmount"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))({
      sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
      unwrapSingleConstructors: false,
      unwrapSingleArguments: true,
      unwrapSingleRecordArguments: true,
      fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
    })
  }
))();
const decodePaymentMethod = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericPaymentMethod)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Cash"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Online"}))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Card"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Prepaid"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Offline"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "CashAndCard"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "BankTransfer"}))))))))
};
export {
  $PaymentMethod,
  BankTransfer,
  Card,
  Cash,
  CashAndCard,
  Offline,
  Online,
  Prepaid,
  SplitPaymentInfo,
  boundedEnumPaymentMethod,
  boundedPaymentMethod,
  decodePaymentMethod,
  decodeSplitPaymentInfo,
  encodePaymentMethod,
  encodeSplitPaymentInfo,
  encodingOpts,
  enumPaymentMethod,
  eqPaymentMethod,
  eqSplitPaymentInfo,
  genericPaymentMethod,
  genericSplitPaymentInfo,
  hasFieldSplitPaymentInfo,
  newtypeSplitPaymentInfo_,
  ordPaymentMethod,
  showPaymentMethod,
  showSplitPaymentInfo,
  unscrambleDecodePaymentMethod,
  unscrambleDecodeSplitPaymentInfo
};
